define('common/js/lib/Serum.ScrollTrigger',[
  'jquery',
  'common/js/lib/Serum.Pubsub',
  'common/js/lib/jquery/plugins/jquery-throttle-debounce/1.1/jquery-throttle-debounce.min'
], function($, Pubsub) {
  'use strict';

  /** @const */
  var DEFAULT_OFFSET_BUFFER = 250,
    TRIGGER_THROTTLE = 500,
    MAX_TRIGGER_COUNT = 1;

  var $window = $(window);

  /** @private @static */
  function onscroll() {
    Pubsub.publish(Pubsub.topics.DID_SCROLL, getPosition());
  }

  /** @private @static */
  function getPosition() {
    var top = $window.scrollTop();
    return { top : top, bottom: top + winheight() };
  }

  /** @private @static */
  var winheight = (function (){
    if(window.innerHeight) {
      return function() {
        return window.innerHeight;              // the rest
      };
    }
    return function() {
      return document.documentElement.clientHeight;    // IE8-
    };
  }());

  /**
   * Setup singular scroll event handler
   *
   * @public
   */
  function initialize() {
    $(window).on('scroll', onscroll);
    $(window).on('unload', destroy);
  }

  /** @public */
  function destroy() {
    $(window).off('scroll', onscroll);
  }

  /** @public */
  function constructor($element, callback, options) {

    /** @private */
    var topOffset,
      boundScroll,
      triggerCount; // eslint-disable-line no-unused-vars

    options = $.extend({
      throttle : TRIGGER_THROTTLE,
      triggerCount : MAX_TRIGGER_COUNT,
      offsetBuffer : DEFAULT_OFFSET_BUFFER
    }, options || {});

    /** @private */
    function setupEvents() {
      boundScroll = options.throttle ? $.throttle(options.throttle, scroll) : scroll;

      topOffset = $element.offset().top - options.offsetBuffer;
      Pubsub.subscribe(Pubsub.topics.DID_SCROLL, boundScroll);
      boundScroll(getPosition());
    }

    /** @private */
    function scroll(position) {
      if (position.bottom > topOffset) {
        options.triggerCount--;
        if(isFinalTrigger()) {
          Pubsub.unsubscribe(Pubsub.topics.DID_SCROLL, boundScroll);
        }
        callback(position);
      }
    }

    /** @private */
    function isFinalTrigger() {
      return !options.triggerCount;
    }

    function remove() {
      Pubsub.unsubscribe(Pubsub.topics.DID_SCROLL, boundScroll);
    }

    // setup events
    if ($element.length) {
      setTimeout(setupEvents, 0);
    }

    return {
      remove: remove
    };
  }

  constructor.initialize = initialize;
  constructor.destroy = destroy;

  return constructor;

});
